<script setup>
import BabyIcon from './prompt_icons/BabyIcon.vue'
import SuitcaseIcon from './prompt_icons/Suitcase.vue'
import PetIcon from './prompt_icons/PetIcon.vue'
import { useI18n } from "vue-i18n";

defineEmits(['templatePromptClicked'])

const { t } = useI18n();
</script>

<script>
export default {
  data() {
    return {
      // Define image paths here, similar to the example component
      bannerImage: new URL('../assets/air_montenegro_banner.png', import.meta.url).href,
      logoImage: new URL('../assets/air_mne_horizontal_logo@1x.png', import.meta.url).href
    };
  }
}
</script>

<template>
  <div class="flex min-h-0 w-full flex-col">
    <div
      class="relative flex h-[18rem] items-center justify-center"
      :style="{ backgroundImage: `url(${bannerImage})`, backgroundSize: 'cover', backgroundPosition: 'center 35%' }"
    >
      <div
      class="absolute bottom-0 left-0 h-24 w-full bg-gradient-to-b from-transparent to-slate-100"
      />

      <div class="relative z-10 flex flex-col items-center">
        <!-- <img
          class="h-28 w-auto object-cover md:block lg:h-40"
          :src="logoImage"
          alt="Air Montenegro"
        /> -->
        <h1 class="mb-3 text-center font-bold text-white text-[2rem]" style="text-shadow: 0 1px 3px rgba(0,0,0,0.5);">
          Supersteward
        </h1>
      </div>
    </div>

    <div class="relative -top-8 flex flex-col gap-4 px-4 lg:px-8">
      <div
        class="hidden h-24 cursor-pointer items-center gap-2 rounded-[12px] border border-gray-200 bg-white p-4 shadow-sm hover:bg-gray-100 md:flex lg:h-auto"
        @click="
          $emit(
            'templatePromptClicked',
            t('defaultQuestion.luggageQuestion')
          )
        "
      >
        <div>
          <SuitcaseIcon />
        </div>
        <span class="text-gray-darker">
          {{t("defaultQuestion.luggageQuestion")}}
        </span>
      </div>
      <div
        class="flex h-24 cursor-pointer items-center gap-2 rounded-[12px] border border-gray-200 bg-white p-4 shadow-sm hover:bg-gray-100 lg:h-auto"
        @click="
          $emit(
            'templatePromptClicked',
            t('defaultQuestion.petQuestion'),
          )
        "
      >
        <div>
          <PetIcon/>
        </div>
        <span class="text-gray-darker">
          {{t("defaultQuestion.petQuestion")}}
        </span>
      </div>
      <div
        class="flex h-24 cursor-pointer items-center gap-2 rounded-[12px] border border-gray-200 bg-white p-4 shadow-sm hover:bg-gray-100 lg:h-auto"
        @click="
          $emit(
            'templatePromptClicked',
            t('defaultQuestion.childMonitoringQuestion'),
          )
        "
      >
        <div>
          <BabyIcon />
        </div>
        <span class="text-gray-darker">
          {{t("defaultQuestion.childMonitoringQuestion")}}
        </span>
      </div>
    </div>
  </div>
</template>